import { render, staticRenderFns } from "./StandardFamilyPage.vue?vue&type=template&id=04805c2f"
import script from "./StandardFamilyPage.vue?vue&type=script&lang=js"
export * from "./StandardFamilyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports